type AuthoredReport = {
	primary_author?: string | null;
	author?: string | null;
};

// The email of a report's author. Reports from before 2026-09-01 only have
// `author`, and an empty primary_author falls back to it as well.
export const getReportAuthorEmail = (report?: AuthoredReport | null) =>
	report?.primary_author || report?.author; // NOSONAR: an empty primary_author falls back to author
